export default __webpack_public_path__ + "static/media/hewlett-packard--white.57dfe28d.svg";